module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copy-rotate text-dark"
  }, [_c('button', {
    ref: "copy_calendars_button",
    class: {
      'do-bttn': _vm.activeCalendarDate
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleDropdown.apply(null, arguments)
      }
    }
  }, [_vm._v("Rotating schedule\n  ")]), _vm._v(" "), (_vm.isDropdown) ? _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "showClose": false
    }
  }, [_c('div', {
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "copy-calendars__panel"
  }, [_c('div', {
    staticClass: "copy-rotate__header"
  }, [_c('h3', [_vm._v("Rotating schedule:\n            "), (!_vm.isSeeDates) ? [_vm._v("Select days to copy")] : [_vm._v("Select dates to insert")]], 2), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle",
    on: {
      "click": _vm.closeDropdown
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "copy-rotate__body"
  }, [(!_vm.isSeeDates) ? _c('div', [(_vm.isLoading || _vm.isLoadingSchoolSettings) ? _c('Loader', {
    attrs: {
      "bg-color": "#fff"
    }
  }) : [_c('div', {
    staticClass: "d-copy-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("\n                Number of days\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "d-number-picker"
  }, [_c('button', {
    on: {
      "click": _vm.subtractDay
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numberOfDays),
      expression: "numberOfDays"
    }],
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.numberOfDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numberOfDays = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.addDay
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "copy-rotate__number-of-days"
  }, _vm._l((_vm.daysToCopy), function(day, index) {
    return _c('li', {
      key: index
    }, [_c('p', {
      staticClass: "d-circle"
    }, [_vm._v(_vm._s(day.label))]), _vm._v(" "), _c('DateSelector', {
      attrs: {
        "date": day.date
      },
      on: {
        "changed": function($event) {
          return _vm.setDayToCopyDate($event, index)
        }
      }
    })], 1)
  }), 0)])]], 2) : _vm._e(), _vm._v(" "), (_vm.isSeeDates) ? _c('CopyCalendarRotateDates', {
    attrs: {
      "initStartDate": _vm.initStartPasteDate,
      "schoolId": _vm.schoolId,
      "daysToCopy": _vm.daysToCopy
    },
    on: {
      "pasteDates": _vm.setPasteDates
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "copy-rotate__footer"
  }, [(_vm.isSeeDates) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.isSeeDates = false
      }
    }
  }, [_vm._v("Back to number of days")]) : _vm._e(), _vm._v(" "), (!_vm.isSeeDates) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.isSeeDates = true
      }
    }
  }, [_vm._v("See dates")]) : _vm._e(), _vm._v(" "), (_vm.isSeeDates) ? _c('button', {
    staticClass: "bttn bttn-primary",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit days")]) : _vm._e()])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29814708!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CopyCalendarRotate/CopyCalendarRotate.vue
// module id = 1517
// module chunks = 1